import { MinimalInfinitScrollingTable } from "../../../-components/infinit-scrolling-table/minimal-infinit-scrolling-table"
import {
  ActivityDto,
  ActivityListRequest,
} from "../../../../../@client/Theasoft_ApiServer_Activities"
import { PaginatedListRequest } from "../../../-components/infinit-scrolling-list"
import { useActivityTableColumns } from "./use-activity-table-columns"
import { ExclusiveProperties } from "../../../../../utils/exclusive-properties"
interface Props {
  partialInput: ExclusiveProperties<ActivityListRequest, PaginatedListRequest>
  onClickRow: (activity: ActivityDto) => void
}
export function MinimalActivityTable({ partialInput, onClickRow }: Props) {
  const { baseColumns } = useActivityTableColumns()
  return (
    <MinimalInfinitScrollingTable
      url="/api/Activity/GetActivityList"
      partialInput={partialInput}
      columnDefinitions={baseColumns}
      onClickRow={onClickRow}
    />
  )
}
